import { render, staticRenderFns } from "./tenderTotal.vue?vue&type=template&id=050e3808&scoped=true&"
import script from "./tenderTotal.vue?vue&type=script&lang=js&"
export * from "./tenderTotal.vue?vue&type=script&lang=js&"
import style0 from "./tenderTotal.vue?vue&type=style&index=0&id=050e3808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050e3808",
  null
  
)

export default component.exports